export const DEFAULT_DRAWER_DETAIL_WIDTH = 1120;
export const RESIZABLE_MIN_WIDTH = 68;
export const SORT_DIRECTIONS: ('descend' | 'ascend')[] = ['descend', 'ascend'];
